// extracted by mini-css-extract-plugin
export default {"Electrical":"Electrical_Electrical__5mrG7"};